import React from 'react';
import './Loader.css'

import PciImage from './assets/pci.jpg'
import VisaImage from './assets/visa.svg'
import MasterImage from './assets/master.jpg'


const Loading = () => {


    const firstDigit = localStorage.getItem('first-digit');

    // Determine the image source and alt text
    let imageSrc, altText;
    if (firstDigit === '4') {
      imageSrc = VisaImage;
      altText = 'Visa';
    } else if (firstDigit === '5') {
      imageSrc = MasterImage;
      altText = 'Mastercard';
    } else {
      imageSrc = null; // No image if not 4 or 5
      altText = 'No card';
    }
  return (
    <div className="flex items-center justify-center w-full min-h-screen bg-gray-50">
      <div className="w-full max-w-sm px-6 py-8 bg-white border border-gray-200 rounded-lg shadow-sm">
        <div className="flex flex-col items-center justify-between w-full mb-6">
          <img
            src={PciImage} 
            alt="PCI DSS Compliant"
            className="h-10 mb-8"
          />

          <div className="my-8 cus-loader"></div>
          
          <div className="flex items-center justify-center gap-6 mt-8">
            {imageSrc && (
              <img src={imageSrc} alt={altText} className="h-8 w-auto object-contain" />
            )}
            {imageSrc && <div className="h-8 w-px bg-gray-300"></div>}
            
          </div>
        </div>

      </div>
    </div>
  );
};

export default Loading;

